import React from 'react';
import { ViewJobViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: ViewJobViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
